import React from "react";
import { motion } from "framer-motion";

const Icon = ({ className, ...rest }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth="1.5"
      stroke="currentColor"
      className={className}
      {...rest}
    >
      <path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12m6-6H6" />
    </svg>
  );
};

const ValueCard = ({ title, icon, description, bgColor }) => {
  return (
    <motion.div 
      className={`value-card ${bgColor || "bg-gray-800"}`}
      whileHover={{ 
        scale: 1.05,
        boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)"
      }}
      transition={{ type: "spring", stiffness: 300 }}
    >
      <div className="value-card-icon">
        {icon}
      </div>
      <h3 className="value-card-title">{title}</h3>
      <p className="value-card-description">{description}</p>
    </motion.div>
  );
};

const ValuesWithCanvasEffect = ({ valuesData }) => {
  return (
    <div className="values-grid">
      {valuesData.map((value, index) => (
        <ValueCard
          key={index}
          title={value.title}
          icon={<Icon className="h-6 w-6 text-white" />}
          description={value.description}
          bgColor={value.bgColor}
        />
      ))}
    </div>
  );
};

export default ValuesWithCanvasEffect;
